import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { makeWager as makeWagerApi } from '../../../api-calls/wagers'
import { makeWager as makeContractWager } from '../../../contract/WagersController'
import UserStore from '../../../stores/UserStore';
import { message } from 'antd'

@inject("web3Store", "eventStore", "WagerStore", "UserStore", "AuthStore")
@observer class StepOne extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIncrement: 0.05,
            currentOddsIncrement: 1,
        };
        this.handleIncrement = this.handleIncrement.bind(this);
        this.handleDecrement = this.handleDecrement.bind(this);
        this.handleOddsIncrement = this.handleOddsIncrement.bind(this);
        this.handleOddsDecrement = this.handleOddsDecrement.bind(this);
        this.makeBet = this.makeBet.bind(this);
    }

    round(value) {
        return Math.round(value * 100) / 100;
    }

    handleIncrement() {
        this.setState({ currentIncrement: this.state.currentIncrement + 0.05 }, () => {
            console.log(this.round(this.state.currentIncrement));
        });
    }

    handleDecrement() {
        if (this.state.currentIncrement > 0.05) {
            this.setState({ currentIncrement: this.state.currentIncrement - 0.05 }, () => {
                console.log(this.round(this.state.currentIncrement));
            });
        }
    }

    handleOddsIncrement() {
        this.setState({ currentOddsIncrement: this.state.currentOddsIncrement + 0.25 }, () => {
            console.log(this.round(this.state.currentOddsIncrement));
        });

    }

    handleOddsDecrement() {
        if (this.state.currentOddsIncrement >= 0.50) {
            this.setState({ currentOddsIncrement: this.state.currentOddsIncrement - 0.25 }, () => {
                console.log(this.round(this.state.currentOddsIncrement));
            });
        }
    }
    onChange(event) {
        console.log(event.target.value);
    }

    makeBet() {
        const { web3Store, AuthStore, UserStore, WagerStore } = this.props;
        const { makerChoice, team_one, team_two, eventId, eventBytes32Id } = this.props;
        let teamName = "";
        let authToken = AuthStore.userAuth.auth.accessToken;
        console.log("Auith token at step one " + authToken);
        let userId = UserStore.user._id;
        const ethMultiplier = 1000000000000000000;

        if (makerChoice == 1) {
            teamName = team_one;
        }
        else if (makerChoice == 2) {
            teamName = team_two;
        }
        else {
            teamName = "Draw";
        }

        const wagerBytes32Id = web3Store.web3.utils.sha3(teamName + eventId + makerChoice + (+Date.now()));
        console.log("bytes32Id" + wagerBytes32Id);
        console.log("Team Name" + teamName);
        console.log("Maker Choice" + makerChoice);
        let self = this;
        makeContractWager(wagerBytes32Id, eventBytes32Id, this.state.currentIncrement * ethMultiplier, this.state.currentOddsIncrement * 100, makerChoice - 1).then( //SUBTRACT 1 from maker choice becasue contract (0= team one) and (1= team 2)
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! No bet made.");
                } else {
                    return makeWagerApi(authToken,
                        userId,
                        wagerBytes32Id,
                        eventId,
                        web3Store.account,
                        self.state.currentIncrement,
                        self.state.currentOddsIncrement,
                        makerChoice,
                        false,
                        false).then(function () {
                            WagerStore.queryEventWagers(eventId);

                            return UserStore.updateUser(AuthStore.userAuth.auth.accessToken);
                        });
                }
            });

        this.props.closeBetModal();
        // return makeApiEvent(
        //     authToken,
        //     eventBytes32Id,
        //     apiTeams,
        //     drawPossible,
        //     startTime,
        //     duration,
        //     makerBond,
        //     web3Store.account,
        //     false,
        //     categoryId
        // ).then(function () {

        // });
    }

    render() {

        let potentialWinValue = (this.state.currentIncrement * this.state.currentOddsIncrement);

        const { makerChoice, team_one, team_two, eventId } = this.props;
        let teamName = "";
        if (makerChoice == 1) {
            teamName = team_one;
        }
        else if (makerChoice == 2) {
            teamName = team_two;
        }
        else {
            teamName = "Draw";
        }
        console.log(teamName);
        console.log(makerChoice);
        console.log(eventId);

        return (
            <div className="step-one">
                <h3>You are making a bet in favor of: <img src="http://www.countryflags.io/CA/flat/64.png" width="30px" />{teamName}</h3>
                <div className="step-one-grid">
                    <div className="bet-amount">
                        <h3 style={{ textAlign: 'center' }}>Bet Value</h3>
                        <div className="ctrl">
                            <div onClick={this.handleIncrement} className="ctrl__button ctrl__button--decrement">
                            </div>
                            <div className="ctrl__counter">
                                <input onChange={this.onChange} className="ctrl__counter-input" maxLength={10} minLength={0} type="text" value={this.round(this.state.currentIncrement)} /><span style={{ color: "#1f8ffb" }}> ETH</span>
                            </div>
                            <div onClick={this.handleDecrement} className="ctrl__button ctrl__button--increment">
                            </div>
                        </div>
                    </div>
                    <div className="bet-odds">
                        <h3 style={{ textAlign: 'center' }}>Bet Odds</h3>
                        <div className="ctrl">
                            <div onClick={this.handleOddsIncrement} className="ctrl__button ctrl__button--decrement">
                            </div>
                            <div className="ctrl__counter">
                                <input onChange={this.onChange} className="ctrl__counter-input" maxLength={10} minLength={0} type="text" value={this.state.currentOddsIncrement} /><span style={{ color: "#1f8ffb" }}> : 1</span>
                            </div>
                            <div onClick={this.handleOddsDecrement} className="ctrl__button ctrl__button--increment">
                            </div>
                        </div>
                    </div>
                </div>
                <p style={{ textAlign: 'center' }}>Potential Win: <span style={{ color: "#1f8ffb" }}>~{this.round(potentialWinValue)} ETH</span></p>
                <div style={{ textAlign: 'right' }}><button onClick={this.makeBet}>Make bet</button></div>
            </div>
        );
    }
}

export default StepOne;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/betSteps/StepOne.js